import axios from 'axios';
import * as actions from './actionsTypes';
import messages from '../../messages';
import dashboardSelecRespServices from './dashboardSelecResp.services';

export const getDashboardSelecResp = (filters) => async dispatch => {
  try {
    dispatch({
      type: actions.LOADING_DASHBOARD_SELECT_RESPONSIBLE_BOX,
      payload: true
    });

    const resp = await dashboardSelecRespServices.getDashboarSelecResp(filters);
    const oData = resp.data;

    console.log("estos son los datos: Barra", oData)
    oData.datasets[0].backgroundColor = '#0070b8';
    oData.datasets[0].hoverBackgorundColor = '#0070b8';
    oData.datasets[1].backgroundColor = '#e48100';
    oData.datasets[1].hoverBackgorundColor = '#e48100';
    oData.datasets[2].backgroundColor = 'grey';
    oData.datasets[2].hoverBackgorundColor = 'grey';

    dispatch({
      type: actions.GET_DASHBOARD_SELECT_RESPONSIBLE_BOX,
      payload: oData
    });
  } catch (ex) {
    let message = '';
    if (axios.isAxiosError(ex)){
      if(ex.response?.data){
        message = ex.response.data.message;
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.DASHBOARD_SELECT_ERROR,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.LOADING_DASHBOARD_SELECT_RESPONSIBLE_BOX,
      payload: false
    });
  }
}